(function ($, Drupal, once) {
  Drupal.behaviors.expandCollapsedMenu = {
    attach: function attach(context) {
      const $container = $('.page-template');
      const $userMenu = $('.sidebar-menu .user-menu');
      $(once('sidebar-menu-accordion', '.sidebar-menu', context)).on({
        mouseenter() {
          if (
            $container.hasClass('menu-collapsed') &&
            !$container.hasClass('is-expanded')
          ) {
            $container.addClass('is-expanded');
          }
        },
        mouseleave() {
          if (
            $container.hasClass('menu-collapsed') &&
            $container.hasClass('is-expanded')
          ) {
            $container.removeClass('is-expanded');
            const $dropdown = $userMenu.find('.dropdown-menu');
            if ($dropdown.hasClass('show')) {
              $userMenu.dropdown('toggle');
              // This listener stops links working, not sure why.
              $userMenu.off('click');
            }
          }
        },
      });
    },
  };

  Drupal.behaviors.expandMobileMenu = {
    attach: function attach(context) {
      once('d7-mobile-menu-toggle', '.d7-mobile-menu-toggle', context).forEach(
        function (element) {
          const $menuToggle = $(element);
          $menuToggle.on('click', () => {
            if ($('.d7-mobile-menu-bar .veolia-menu').is(':visible')) {
              $('.d7-mobile-menu-bar .veolia-menu').slideUp();
            } else {
              $('.d7-mobile-menu-bar .veolia-menu').slideDown();
            }
          });
        },
      );
    },
  };
}(jQuery, Drupal, once));
